import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import AfFilterList from './containers/AfFilterList';
import AfFilterCreate from './containers/AfFilterCreate';
import AfFilterView from './containers/AfFilterView';
import {
  SYSTEM_CONFIGURATION_ROUTE,
  AF_FILTER,
  FILTER_SETTING
} from '../../constants';

interface Props {
}

const AfFilter: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${AF_FILTER}`}>
        <AfFilterList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${AF_FILTER}/create`}>
        <AfFilterCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${AF_FILTER}/view`}>
        <AfFilterView />
      </Route>
    </Fragment>
  );
};

export default AfFilter;
